import { render, staticRenderFns } from "./SubGroups.vue?vue&type=template&id=ab6afc32&scoped=true&"
import script from "./SubGroups.vue?vue&type=script&lang=js&"
export * from "./SubGroups.vue?vue&type=script&lang=js&"
import style0 from "./SubGroups.vue?vue&type=style&index=0&id=ab6afc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6afc32",
  null
  
)

export default component.exports